import { createFileRoute, redirect } from '@tanstack/react-router'

import { z } from 'zod'

import { env } from '@/env'
import { forbiddenErrorComponent, requirePermission } from '@/lib/routeGuards'
import { NotebookAnalysis } from '@/pages/NotebookAnalysis/NotebookAnalysis'

// ``from`` records where the analysis was opened from (provenance); retained on
// the URL for existing links, but the page no longer renders an origin crumb.
const notebookSessionSearchSchema = z.object({
  from: z.enum(['logs', 'control-room', 'lens']).optional().catch(undefined),
  // Lens flow: the notebook asset the analysis started from (lineage for save).
  sourceAssetId: z.string().optional().catch(undefined),
})

export const Route = createFileRoute('/_app/notebook/session/$sessionId')({
  component: NotebookSessionRoute,
  validateSearch: notebookSessionSearchSchema,
  beforeLoad: ({ context }) => {
    // Feature flag: with notebooks off, the route is unreachable even by direct
    // navigation (the entry button is gated separately in AnalyseInNotebookButton).
    if (!env.VITE_NOTEBOOK_ANALYSIS_ENABLED) {
      throw redirect({ to: '/library' })
    }
    requirePermission(context.permissions, 'read:audit_logs')
  },
  errorComponent: forbiddenErrorComponent,
})

function NotebookSessionRoute() {
  const { sessionId } = Route.useParams()
  const { sourceAssetId } = Route.useSearch()

  return (
    <NotebookAnalysis sessionId={sessionId} sourceAssetId={sourceAssetId} />
  )
}
